<template>
  <div style="margin: 15px">
    
  </div>
</template>

<script>
export default {
  name: "DashboardAdmin",
  data() {
    return {
      obj: {},
      blogRunTime: "",
    };
  },
  mounted() {
    // this.getData();
  },
  methods: {
    getData() {
      var params = {};
      this.$api.dashboard
        .tronscanValue(params)
        .then((res) => {
          this.obj = res;
          let staytimeGap =
            new Date().getTime() - new Date(this.obj.modifyDate).getTime();
          let stayDay = Math.floor(staytimeGap / (3600 * 1000 * 24));
          let leave = staytimeGap % (3600 * 1000 * 24);
          let stayHour = Math.floor(leave / (3600 * 1000));
          let leave1 = leave % (3600 * 1000);
          let stayMin = Math.floor(leave1 / (60 * 1000));
          let leave2 = leave1 % (60 * 1000);
          let staySec = Math.floor(leave2 / 1000);
          if (stayDay == 0) {
            if (stayHour == 0) {
              this.blogRunTime = stayMin + "分" + staySec + "秒";
            } else {
              this.blogRunTime =
                stayHour + "时" + stayMin + "分" + staySec + "秒";
            }
          } else {
            this.blogRunTime =
              stayDay +
              "天" +
              stayHour +
              "时" +
              stayMin +
              "分" +
              staySec +
              "秒";
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
